"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var rxjs_1 = require("rxjs");
var core_1 = require("@ngx-translate/core");
var core_2 = require("@uirouter/core");
var lodash_1 = __importDefault(require("lodash"));
var toaster_logger_service_1 = require("../core/toaster-logger.service");
var constants_1 = require("../constants");
var constants_2 = require("../core/constants");
var storage_service_1 = require("../modules/storage/storage.service");
var user_service_1 = require("./user.service");
var dealer_service_1 = require("./dealer.service");
var authorization_service_1 = require("./authorization.service");
var dealer_settings_service_1 = require("./dealer-settings.service");
var i0 = __importStar(require("@angular/core"));
var i1 = __importStar(require("@ngx-translate/core"));
var i2 = __importStar(require("@uirouter/core"));
var i3 = __importStar(require("../modules/storage/storage.service"));
var i4 = __importStar(require("./authorization.service"));
var i5 = __importStar(require("../core/toaster-logger.service"));
var i6 = __importStar(require("./user.service"));
var i7 = __importStar(require("./dealer.service"));
var i8 = __importStar(require("./dealer-settings.service"));
var MenuService = /** @class */ (function () {
    function MenuService(translateService, stateService, storageService, authorizationService, logger, userService, dealerService, dealerSettingsService) {
        this.translateService = translateService;
        this.stateService = stateService;
        this.storageService = storageService;
        this.authorizationService = authorizationService;
        this.logger = logger;
        this.userService = userService;
        this.dealerService = dealerService;
        this.dealerSettingsService = dealerSettingsService;
        this._moduleIds = [];
        this.siteMapReadySubject = new rxjs_1.ReplaySubject(1); // could also use BehaviorSubject but that requires initial value which we are not using here
        this.siteMapReady = this.siteMapReadySubject.asObservable();
    }
    Object.defineProperty(MenuService.prototype, "siteMap", {
        get: function () { return this._siteMap; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MenuService.prototype, "moduleIds", {
        get: function () { return this._moduleIds; },
        enumerable: true,
        configurable: true
    });
    MenuService.prototype.getModulePermissions = function (moduleIds) {
        return {
            opportunities: moduleIds.indexOf(constants_1.Modules.opportunities) > -1,
            activities: moduleIds.indexOf(constants_1.Modules.activities) > -1,
            search: moduleIds.indexOf(constants_1.Modules.search) > -1,
            financeInsuranceManager: moduleIds.indexOf(constants_1.Modules.financeInsuranceManager) > -1,
            preOwnedManager: moduleIds.indexOf(constants_1.Modules.preOwnedManager) > -1,
            serviceManager: moduleIds.indexOf(constants_1.Modules.serviceManager) > -1,
            conquests: moduleIds.indexOf(constants_1.Modules.conquests) > -1,
            wishlist: moduleIds.indexOf(constants_1.Modules.wishlist) > -1
        };
    };
    MenuService.prototype.getSiteMap = function (dealerIds) {
        var _this = this;
        if (!dealerIds) {
            this.siteMapReadySubject.next();
            return Promise.resolve(null);
        }
        var currentSiteMap = this.siteMap;
        if (currentSiteMap) {
            this.siteMapReadySubject.next();
            return Promise.resolve(currentSiteMap);
        }
        else {
            // getAccessRights is not used here, its only called here in order to get the accessRights into sessionStorage
            // at app startup. Don't remove it.
            return Promise.all([this.authorizationService.getModuleIds(dealerIds),
                this.authorizationService.getAccessRightIds(dealerIds)])
                .then(function (result) { return _this.resolveSiteMap(result[0]); });
        }
    };
    MenuService.prototype.resolveSiteMap = function (moduleIds) {
        return __awaiter(this, void 0, void 0, function () {
            var siteMap;
            var _this = this;
            return __generator(this, function (_a) {
                siteMap = constants_1.SubMenu;
                return [2 /*return*/, this.loadMenu(siteMap, moduleIds)
                        .then(function () {
                        _this._siteMap = siteMap;
                        _this._moduleIds = moduleIds;
                        var runAsLimited = _this.storageService.getItem('runAsLimited');
                        if (runAsLimited) {
                            if (_this.stateService.current.name === 'home') {
                                _this.storageService.removeItem('runAsLimited');
                                _this.stateService.go('home', {}, { reload: true });
                            }
                            else {
                                _this.stateService.go('limited', {}, { reload: true });
                            }
                        }
                        else if (_this.stateService.current.name === 'loginLanding') {
                            _this.stateService.go('login', {}, { reload: true });
                        }
                        else if (_this.stateService.current.name === 'home') {
                            _this.stateService.go('home', {}, { reload: true });
                        }
                        _this.siteMapReadySubject.next();
                        return siteMap;
                    })];
            });
        });
    };
    MenuService.prototype.getHomeRoute = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                if (this.siteMap) {
                    return [2 /*return*/, this.userService.getUserProfile()
                            .then(function (userProfile) {
                            if (userProfile.isSltUser) {
                                return 'opportunities';
                            }
                            else {
                                return _this.siteMap[0].id;
                            }
                        })];
                }
                else {
                    return [2 /*return*/, null];
                }
                return [2 /*return*/];
            });
        });
    };
    MenuService.prototype.redirectToUserHome = function () {
        var _this = this;
        if (this.stateService.current.name === 'login') {
            var localRedirect = this.storageService.getItem('localRedirectPath');
            if (localRedirect && localRedirect !== '/') {
                this.storageService.removeItem('localRedirectPath');
                var runAsLimited = this.storageService.getItem('runAsLimited');
                if (runAsLimited) {
                    localRedirect = runAsLimited;
                }
                var menuItem = this.findMenuItemByUrl(localRedirect.substr(1));
                if (menuItem) {
                    this.stateService.go(menuItem.id);
                }
                else {
                    // not authorized
                    if (localRedirect.indexOf('deal-sheet') > -1 ||
                        localRedirect.indexOf('reports') > -1 ||
                        localRedirect.toLowerCase().indexOf('activities') > -1
                        || localRedirect.indexOf('external/dealsheet') > -1 || localRedirect.indexOf('external/page') > -1
                        || localRedirect.toLowerCase().indexOf('/security/user/notification') > -1
                        || localRedirect.toLowerCase().indexOf('/alert-desk/dashboard/manager') > -1
                        || localRedirect.toLowerCase().indexOf('/limited/dashboard') > -1) {
                        window.location.assign(localRedirect);
                    }
                    else {
                        this.translateService.get([constants_1.TranslateErrorKeys.unauthorizedPageErrorKey, constants_2.WarningTitleKey])
                            .subscribe(function (translations) {
                            _this.logger.warning(translations[constants_1.TranslateErrorKeys.unauthorizedPageErrorKey], null, translations[constants_2.WarningTitleKey]);
                            _this.stateService.go('home', {}, { reload: true });
                        });
                    }
                }
            }
            else {
                this.stateService.go('home', {}, { reload: true });
            }
        }
    };
    MenuService.prototype.findMenuItemByUrl = function (url) {
        var menuItem = lodash_1.default.find(this.siteMap, { 'url': url });
        if (!menuItem) {
            for (var i = 0; i < this.siteMap.length; i++) {
                menuItem = lodash_1.default.find(this.siteMap[i].subMenuItems, { 'url': url });
                if (menuItem) {
                    return menuItem;
                }
            }
        }
        return menuItem;
    };
    MenuService.prototype.loadMenu = function (siteMap, moduleIds) {
        return __awaiter(this, void 0, void 0, function () {
            var dataEntry;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.removeInaccessibleTopMenuItemsSync(siteMap, moduleIds);
                        this.removeInaccessibleSubMenuItemsSync(siteMap, moduleIds);
                        this.removeServiceDriveOfferMenuIfDisabledSync(siteMap);
                        this.setDealerSettingsLink(siteMap);
                        return [4 /*yield*/, this.removeInaccessibleSltTopMenuItems(siteMap)];
                    case 1:
                        siteMap = _a.sent();
                        return [4 /*yield*/, this.disableInaccessibleSltTopMenuItems(siteMap)];
                    case 2:
                        siteMap = _a.sent();
                        return [4 /*yield*/, this.disableInaccessibleSltSubMenuItems(siteMap)];
                    case 3:
                        siteMap = _a.sent();
                        dataEntry = lodash_1.default.find(siteMap, { 'id': 'dataEntry' });
                        if (dataEntry) {
                            dataEntry.disabled = true;
                        }
                        return [2 /*return*/, Promise.resolve(null)];
                }
            });
        });
    };
    MenuService.prototype.removeInaccessibleTopMenuItemsSync = function (siteMap, moduleIds) {
        var indicesToRemove = new Array();
        for (var i = 0; i < siteMap.length; i++) {
            var menuItem = siteMap[i];
            var accessible = menuItem.authorize ? false : true;
            if (!accessible) {
                for (var j = 0; j < moduleIds.length; j++) {
                    var moduleId = moduleIds[j];
                    if (menuItem.moduleIds.includes(moduleId)) {
                        accessible = true;
                    }
                }
            }
            if (!accessible || menuItem.disabled) {
                indicesToRemove.push(i);
            }
        }
        for (var k = indicesToRemove.length - 1; k >= 0; k--) {
            siteMap.splice(indicesToRemove[k], 1);
        }
    };
    MenuService.prototype.removeInaccessibleSubMenuItemsSync = function (siteMap, moduleIds) {
        var allIndicesToRemove = [[]];
        for (var i = 0; i < siteMap.length; i++) {
            var menuItem = siteMap[i];
            var indicesToRemove = new Array();
            if (menuItem.subMenuItems) {
                for (var j = 0; j < menuItem.subMenuItems.length; j++) {
                    var subMenuItem = menuItem.subMenuItems[j];
                    var accessible = subMenuItem.authorize ? false : true;
                    if (!accessible) {
                        for (var k = 0; k < moduleIds.length; k++) {
                            var moduleId = moduleIds[k];
                            if (subMenuItem.moduleIds.includes(moduleId)) {
                                accessible = true;
                            }
                        }
                    }
                    if (!accessible || subMenuItem.disabled) {
                        indicesToRemove.push(j);
                    }
                }
            }
            allIndicesToRemove.push(indicesToRemove);
        }
        allIndicesToRemove.splice(0, 1);
        for (var l = 0; l < allIndicesToRemove.length; l++) {
            var subIndicesToRemove = allIndicesToRemove[l];
            if (subIndicesToRemove) {
                for (var m = subIndicesToRemove.length - 1; m >= 0; m--) {
                    siteMap[l].subMenuItems.splice(subIndicesToRemove[m], 1);
                }
            }
        }
    };
    MenuService.prototype.removeServiceDriveOfferMenuIfDisabledSync = function (siteMap) {
        if (this.dealerService.getIsSomeDealerOneToOneEnabled()) {
            return;
        }
        this.removeSubMenuItemById(siteMap, 'serviceDriveOffers');
    };
    MenuService.prototype.setDealerSettingsLink = function (siteMap) {
        var _this = this;
        this.dealerSettingsService.UseLegacyDealerSettingsPage().then(function (useLegacyDealerSettings) {
            //Remove portal link
            if (useLegacyDealerSettings) {
                _this.removeSubMenuItemById(siteMap, 'newSettings');
            }
            else { //Remove legacy link
                _this.removeSubMenuItemById(siteMap, 'settings');
            }
        });
    };
    MenuService.prototype.removeSubMenuItemById = function (siteMap, id) {
        lodash_1.default.forEach(siteMap, function (subMenu) {
            var index = lodash_1.default.findIndex(subMenu.subMenuItems, { 'id': id });
            if (index > -1) {
                subMenu.subMenuItems.splice(index, 1);
                return false;
            }
        });
    };
    MenuService.prototype.removeInaccessibleSltTopMenuItems = function (siteMap) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.userService.getUserProfile()
                        .then(function (userProfile) {
                        if (userProfile.isSltUser) {
                            var preOwnedIndex = lodash_1.default.findIndex(siteMap, { 'id': 'preOwned' });
                            if (preOwnedIndex >= 0) {
                                siteMap.splice(preOwnedIndex, 1);
                            }
                        }
                        return siteMap;
                    })];
            });
        });
    };
    MenuService.prototype.disableInaccessibleSltTopMenuItems = function (siteMap) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.userService.getUserProfile()
                        .then(function (userProfile) {
                        if (userProfile.isSltUser) {
                            var alertDesk = lodash_1.default.find(siteMap, { 'id': 'alertDesk' });
                            if (alertDesk) {
                                alertDesk.disabled = true;
                            }
                        }
                        return siteMap;
                    })];
            });
        });
    };
    MenuService.prototype.disableInaccessibleSltSubMenuItems = function (siteMap) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.userService.getUserProfile()
                        .then(function (userProfile) {
                        if (userProfile.isSltUser) {
                            var accessibleSubMenuItems = ['opportunities', 'activities', 'serviceDriveOffers', 'conquests'];
                            var alertDeskMenu = lodash_1.default.find(siteMap, { 'id': 'alertDesk' });
                            if (alertDeskMenu && alertDeskMenu.subMenuItems) {
                                for (var i = 0; i < alertDeskMenu.subMenuItems.length; i++) {
                                    var subMenuItem = alertDeskMenu.subMenuItems[i];
                                    if (accessibleSubMenuItems.indexOf(subMenuItem.id) < 0) {
                                        subMenuItem.disabled = true;
                                    }
                                }
                            }
                        }
                        return siteMap;
                    })];
            });
        });
    };
    MenuService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function MenuService_Factory() { return new MenuService(i0.ɵɵinject(i1.TranslateService), i0.ɵɵinject(i2.StateService), i0.ɵɵinject(i3.StorageService), i0.ɵɵinject(i4.AuthorizationService), i0.ɵɵinject(i5.ToasterLoggerService), i0.ɵɵinject(i6.UserService), i0.ɵɵinject(i7.DealerService), i0.ɵɵinject(i8.DealerSettingsService)); }, token: MenuService, providedIn: "root" });
    return MenuService;
}());
exports.MenuService = MenuService;
